module.exports = __webpack_public_path__ + "static/media/icon-lamb.e2e76a50.svg";